import React, { useEffect, useState } from 'react';
import { category1, category2, category3, photos1, photos2, photos3 } from '../../../assets/images';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import axios from 'axios';

const Photos = () => {

  const { t, i18n } = useTranslation();

  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(true); // loading durumu eklendi

useEffect(() => {
getProducts();
}, []); 

async function getProducts() {
try { 
  // API'den verileri çekiyoruz
  const response = await axios.get('https://www.tanura.az/tanura/photos.php');
  setCategories(response.data);  // Gelen veriyi state'e kaydediyoruz
  setIsLoading(false)
} catch (error) {
  console.error('Error fetching categories:', error);  // Hata durumunda mesaj yazdırıyoruz
}
}
  return (
    <>
   
<div className="md:max-w-container max-w-containerSm mx-auto justify-between mt-[40px] md:mt-[88px]">
      <div className="block md:flex justify-between mx-auto md:mx-0">
    {categories.map((category, index) => (
       <div className="relative md:w-[421px] md:h-[336px] mb-5 md:mb-0">
       <img 
          src={`data:image/jpeg;base64,${category.image}`}
          alt={category.name} 
          className="w-full h-full object-cover"
        />
     </div>
    ))}
      </div>
    </div>
    </>


  );
};
 
export default Photos;
